import axios from 'axios';

//const API_URL = 'http://localhost:5000/api';
const API_URL = 'https://shop-3fje.onrender.com/api';

export const api = axios.create({
  baseURL: API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
